// extracted by mini-css-extract-plugin
module.exports = {"siderwidth":"Siderdrawer_siderwidth__Bxpe7","menu_item":"Siderdrawer_menu_item__OCOOz","list_item":"Siderdrawer_list_item__2LcKW","icon_color":"Siderdrawer_icon_color__qpTQr"};